module.exports = __webpack_public_path__ + "assets/img/detail-content-img-2-c5052ed1.jpg";